import { render, staticRenderFns } from "./chat-drawer.vue?vue&type=template&id=3724e7e8&scoped=true&"
import script from "./chat-drawer.vue?vue&type=script&lang=js&"
export * from "./chat-drawer.vue?vue&type=script&lang=js&"
import style0 from "./chat-drawer.vue?vue&type=style&index=0&id=3724e7e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724e7e8",
  null
  
)

export default component.exports